"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreFollowersWatchers = exports.coreFollowersReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const _idMap_1 = require("./_idMap/index.js");
const get_1 = require("./get.js");
const all_1 = require("./all/index.js");
const post_1 = require("./post.js");
exports.coreFollowersReducers = (0, redux_1.combineReducers)({
    all: all_1.coreFollowedAllReducers,
    byId: _idMap_1.coreFollowedIdMapReducers,
    follow: post_1.postCoreFollowSlice.asyncReducers,
    get: get_1.getCoreFollowedSlice.asyncReducers,
    unfollow: post_1.postCoreUnfollowSlice.asyncReducers
});
exports.coreFollowersWatchers = (0, xuder_1.combineAllWatchers)([
    all_1.coreFollowedAllWatchers,
    get_1.getCoreFollowedSlice.asyncWatchers,
    post_1.postCoreFollowSlice.asyncWatchers,
    post_1.postCoreUnfollowSlice.asyncWatchers
]);
//# sourceMappingURL=index.js.map